export function AuditPayooModel(item) {
    this.id = item.id;
    this.business_date_start = item.business_date_start;
    this.business_date_end = item.business_date_end;
    this.audit_time = item.audit_time;
    this.amount = item.amount;
    this.receive_amount = item.receive_amount;
    this.audit_status = item.audit_status;
    this.status_string = item.status_string;
    this.audit_note = item.note;
}